import { ReactApp } from './react-app';

window.customElements.define(ReactApp.name, ReactApp);



// WEBPACK FOOTER //
// ./src/components/react-app/main.js